import React from 'react'

const BtcIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#F7931A' />
    <path fillRule='evenodd' clipRule='evenodd' d='M23.189 14.02c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.597 6l-.708 2.839c-.376-.086-.744-.17-1.104-.258l.002-.007-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.827.638.805 1.006l-.806 3.235c.048.012.11.03.18.057l-.183-.045-1.13 4.532c-.086.212-.304.53-.797.408.018.025-1.256-.314-1.256-.314l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.717 2.876 1.727.43.708-2.84c.47.127.926.244 1.373.356l-.702 2.813 1.728.43.717-2.876c2.947.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-.535 2.147-4.148.986-5.32.695l.95-3.805c1.17.293 4.918.872 4.37 3.11zm.535-5.567c-.488 1.954-3.498.962-4.474.718l.86-3.45c.976.244 4.11.7 3.614 2.732z' fill='#FFF' />
  </svg>
)

const EthIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#627EEA' />
    <path d='M16 4L15.67 5.1V20.15L16 20.48L22.86 16.42L16 4Z' fill='#FFF' fillOpacity='0.6' />
    <path d='M16 4L9.14 16.42L16 20.48V5.1V4Z' fill='#FFF' />
    <path d='M16 21.86L15.77 22.14V27.67L16 28L22.87 18.42L16 21.86Z' fill='#FFF' fillOpacity='0.6' />
    <path d='M16 28V21.86L9.14 18.42L16 28Z' fill='#FFF' />
    <path d='M16 20.48L22.86 16.42L16 13.31V20.48Z' fill='#FFF' fillOpacity='0.2' />
    <path d='M9.14 16.42L16 20.48V13.31L9.14 16.42Z' fill='#FFF' fillOpacity='0.6' />
  </svg>
)

const SolIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#14F195' />
    <path d='M9.4 19.35a.4.4 0 0 1 .28-.12h12.55a.25.25 0 0 1 .18.43l-2.02 2.02a.4.4 0 0 1-.28.12H7.56a.25.25 0 0 1-.18-.43l2.02-2.02zm0-9a.4.4 0 0 1 .28-.12h12.55a.25.25 0 0 1 .18.43l-2.02 2.02a.4.4 0 0 1-.28.12H7.56a.25.25 0 0 1-.18-.43l2.02-2.02zm12.8 4.5a.4.4 0 0 0-.28-.12H9.37a.25.25 0 0 0-.18.43l2.02 2.02a.4.4 0 0 0 .28.12h12.55a.25.25 0 0 0 .18-.43l-2.02-2.02z' fill='#000' />
  </svg>
)

const LtcIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#345D9D' />
    <path d='M15.3 7h-2.9l-2.2 8.3-1.6.6.6 2.1 1.6-.6-1.1 4.2h12.5l1.1-4.2H14.1l.9-3.4 1.6-.6-.6-2.1-1.6.6 1.7-6.3z' fill='#FFF' />
  </svg>
)

const DogeIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#C2A633' />
    <path d='M12 9h4.5c3.6 0 6.5 2.7 6.5 7s-2.9 7-6.5 7H12V9zm3 3v8h1.5c2 0 3.5-1.6 3.5-4s-1.5-4-3.5-4H15zm-5 3.5h7.5v1.5H10v-1.5z' fill='#FFF' />
  </svg>
)

const UsdtIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#1BA27A' />
    <path
      fill='#FFF'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.9 16.38c-.14.01-1.07.08-1.9.08s-1.74-.06-1.93-.08c-3.05-.14-5.32-1.01-5.32-2.1 0-1.1 2.27-1.96 5.32-2.1v-2.73H8.5V6.5h15v2.95h-5.6v2.73c3.05.14 5.32 1.01 5.32 2.1 0 1.09-2.27 1.96-5.32 2.1v6.62h-3.99v-6.62zm0-2.47v-1.68c-2.9-.13-4.59-.83-4.59-1.23 0-.4 1.69-1.1 4.59-1.23v1.68c2.9.13 4.59.83 4.59 1.23 0 .4-1.69 1.1-4.59 1.23z'
    />
  </svg>
)

const UsdtBep20Icon = ({ size = 24 }) => (
  <span className='relative inline-flex shrink-0' style={{ width: size, height: size }}>
    <UsdtIcon size={size} />
    <svg
      className='absolute -bottom-0.5 -right-0.5'
      width={size * 0.5}
      height={size * 0.5}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <circle cx='8' cy='8' r='7.5' fill='#F3BA2F' stroke='#090B0B' />
      <path d='M8 3.2 9.45 4.65 7.05 7.05 5.6 5.6 8 3.2Zm3.15 3.15L12.6 7.8l-1.45 1.45L9.7 7.8l1.45-1.45ZM8 8.3l1.45 1.45L8 11.2l-1.45-1.45L8 8.3ZM4.85 6.35 6.3 7.8 4.85 9.25 3.4 7.8l1.45-1.45ZM8 11.45l1.45 1.45L8 14.35l-1.45-1.45L8 11.45Z' fill='#FFF' />
    </svg>
  </span>
)

const UsdtPolygonIcon = ({ size = 24 }) => (
  <span className='relative inline-flex shrink-0' style={{ width: size, height: size }}>
    <UsdtIcon size={size} />
    <svg
      className='absolute -bottom-0.5 -right-0.5'
      width={size * 0.5}
      height={size * 0.5}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <circle cx='8' cy='8' r='7.5' fill='#8247E5' stroke='#090B0B' />
      <path transform='translate(1.2 1.8) scale(0.076)' d='M66.8 54.7l-16.7-9.7L0 74.1v58l50.1 29l50.1-29V41.9L128 25.8l27.8 16.1v32.2L128 90.2l-16.7-9.7v25.8l16.7 9.7l50.1-29V29L128 0L77.9 29v90.2l-27.8 16.1l-27.8-16.1V86.9l27.8-16.1l16.7 9.7V54.7z' fill='#FFF' />
    </svg>
  </span>
)

const UsdtEthereumIcon = ({ size = 24 }) => (
  <span className='relative inline-flex shrink-0' style={{ width: size, height: size }}>
    <UsdtIcon size={size} />
    <svg
      className='absolute -bottom-0.5 -right-0.5'
      width={size * 0.5}
      height={size * 0.5}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <circle cx='8' cy='8' r='7.5' fill='#343434' stroke='#090B0B' />
      <path d='M8 2.5 4.8 8l3.2 1.9L11.2 8 8 2.5Zm0 10.9L4.8 8.9 8 10.8l3.2-1.9L8 13.4Z' fill='#FFF' />
    </svg>
  </span>
)

const UsdtTronIcon = ({ size = 24 }) => (
  <span className='relative inline-flex shrink-0' style={{ width: size, height: size }}>
    <UsdtIcon size={size} />
    <svg
      className='absolute -bottom-0.5 -right-0.5'
      width={size * 0.5}
      height={size * 0.5}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <circle cx='8' cy='8' r='7.5' fill='#FF060A' stroke='#090B0B' />
      <path d='m4 4.2 8 .7-3.9 7L4 4.2Zm1.3 1.1 2.8 4.9 2.7-4.5-5.5-.4Z' fill='#FFF' />
    </svg>
  </span>
)

const XrpIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#23292F' />
    <path d='M9.2 10.2h3.1l3.7 4.4 3.7-4.4h3.1l-5.2 6.1 5.4 6.3h-3.1l-3.9-4.6-3.9 4.6H8.9l5.4-6.3-5.1-6.1z' fill='#FFF' />
  </svg>
)

const BnbIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#F3BA2F' />
    <path d='M16 8.2l2.1 2.1-3.5 3.5-2.1-2.1L16 8.2zm5.6 5.6l2.1 2.1-2.1 2.1-2.1-2.1 2.1-2.1zM16 13.8l2.1 2.1L16 18l-2.1-2.1 2.1-2.1zM10.4 13.8l2.1 2.1-2.1 2.1-2.1-2.1 2.1-2.1zM16 19.4l2.1 2.1L16 23.6l-2.1-2.1 2.1-2.1z' fill='#FFF' />
  </svg>
)

const TrxIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#FF060A' />
    <path d='M9.2 10.4l13.6-2.2-6.2 15.4L9.2 10.4zm2.2 1.6l4.4 9.2 3.8-9.6-8.2.4z' fill='#FFF' />
  </svg>
)

const UsdcIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='16' fill='#2775CA' />
    <path d='M16 6a10 10 0 100 20 10 10 0 000-20zm0 2a8 8 0 110 16 8 8 0 010-16zm-1 3v1.65c-2.01.37-3.5 1.63-3.5 3.35 0 1.95 1.75 2.8 3.85 3.2 1.85.35 2.15.8 2.15 1.5 0 .85-.85 1.45-2.1 1.45-1.25 0-2.15-.5-2.5-1.35l-1.6.65c.55 1.4 1.9 2.35 3.7 2.65V23h2v-1.65c2.05-.35 3.5-1.65 3.5-3.35 0-2-1.7-2.75-3.85-3.2-1.8-.35-2.15-.75-2.15-1.45 0-.8.8-1.35 1.9-1.35 1.15 0 1.9.45 2.3 1.25l1.6-.7C19.3 11.8 18 10.95 16.3 10.65V9h-2.3z' fill='#FFF' />
  </svg>
)

export const CryptoLogo = ({ code, name, size = 24 }) => {
  const symbol = (code || name || '').toUpperCase()
  if (symbol === 'USDT_ERC20' || symbol === 'USDT.ERC20') return <UsdtEthereumIcon size={size} />
  if (symbol === 'USDT.TRC20') return <UsdtTronIcon size={size} />
  if (symbol === 'USDT.BEP20') return <UsdtBep20Icon size={size} />
  if (symbol === 'USDT.POL') return <UsdtPolygonIcon size={size} />
  if (symbol.includes('USDT') || symbol.includes('TETHER')) return <UsdtIcon size={size} />
  if (symbol.includes('USDC')) return <UsdcIcon size={size} />
  if (symbol.includes('ETH')) return <EthIcon size={size} />
  if (symbol.includes('SOL')) return <SolIcon size={size} />
  if (symbol.includes('LTC')) return <LtcIcon size={size} />
  if (symbol.includes('DOGE')) return <DogeIcon size={size} />
  if (symbol.includes('XRP') || symbol.includes('RIPPLE')) return <XrpIcon size={size} />
  if (symbol.includes('BNB') || symbol.includes('BINANCE')) return <BnbIcon size={size} />
  if (symbol.includes('TRX') || symbol.includes('TRON')) return <TrxIcon size={size} />
  return <BtcIcon size={size} />
}

export default React.memo(CryptoLogo)
